/* eslint-disable */
import { withStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Popover from '@material-ui/core/Popover';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import React from 'react';
import { compose } from 'redux';
import isFunction from '../../Support/Is/Function/IsFunction';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import MoreMenuPropTypes from './MoreMenu.component.props';
import moreMenuStyles from './MoreMenu.component.styles';

/**
 * MoreMenuComponent
 * @export
 * @class MoreMenuComponent
 * @extends {React.Component<MoreMenuComponentComposedProps, MoreMenuComponentState>}
 */
export class MoreMenuComponent extends React.PureComponent {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<MoreMenuComponentProps>}
   * @memberof MoreMenuComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`MoreMenu`}
   * @memberof MoreMenuComponent
   */
  static displayName = `MoreMenu`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof MoreMenuComponent
   */
  static propTypes = MoreMenuPropTypes;

  /**
   * Data specific to the `<MoreMenuComponent />` instance
   * @type {MoreMenuComponentState}
   * @memberof MoreMenuComponent
   */
  state = {
    anchorEl: null,
  };

  popOverActions = null;

  /**
   * Handle menu icon click
   * @param {Event} event The `click` event
   * @returns {void} void
   * @memberof MoreMenuComponent
   */
  onMenuClick = (event) => {
    if (this.popOverActions) {
      this.popOverActions.updatePosition();
    }
    event.stopPropagation();
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  /**
   * Handle close event and call the callback if specified
   * @param {Function} callback The callback to call on close.
   * @returns {void} void
   * @memberof MoreMenuComponent
   */
  handleClose = (callback) => (event) => {
    event.stopPropagation();
    this.setState({
      anchorEl: null,
    });
    if (isFunction(callback)) {
      callback();
    }
  };

  /**
   * Render the menu items
   * @returns {React.Component} The rendered menu items for `<MoreMenuComponent />`
   * @memberof MoreMenuComponent
   */
  renderMenuItems() {
    const { menuItems } = this.props;
    return menuItems.map(([id, callback, children]) => (
      <MenuItem key={id} onClick={this.handleClose(callback)}>
        {children}
      </MenuItem>
    ));
  }

  /**
   * Render the component
   * @returns {React.Component} The rendered `<MoreMenuComponent />`
   * @memberof MoreMenuComponent
   */
  render() {
    const { classes } = this.props;
    const { anchorEl } = this.state;
    const open = anchorEl !== null;
    return (
      <React.Fragment>
        <IconButton
          aria-haspopup="true"
          classes={{ colorInherit: classes.noPadding }}
          color="inherit"
          disableRipple
          disableTouchRipple
          onClick={this.onMenuClick}
        >
          <MoreVertIcon />
          <Popover
            classes={{paper: classes.paper}}
            action={(actions) => {
              this.popOverActions = actions;
            }}
            anchorEl={anchorEl}
            anchorOrigin={{
              horizontal: `right`,
              vertical: `bottom`,
            }}
            onClose={this.handleClose()}
            open={open}
          >
            <MenuList>{this.renderMenuItems()}</MenuList>
          </Popover>
        </IconButton>
      </React.Fragment>
    );
  }
}

/** @type {React.ComponentClass<MoreMenuComponentProps>} */
const MoreMenu = compose(withStyles(themeCreateInjectableStyles(moreMenuStyles), { withTheme: true }))(MoreMenuComponent);

export default MoreMenu;
